import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiPollBox } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { hasBeekeeperSurveysAccess } from '@lumapps/surveys/ducks/selectors';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { surveysRoute } from '../../routes';

export const SurveysSideNavigation = (props: Partial<SideNavigationItemProps>) => {
    const isAllowed = useSelector(hasBeekeeperSurveysAccess);
    const { translateKey } = useTranslate();

    if (isAllowed) {
        return (
            <SideNavigationItem
                {...props}
                route={surveysRoute}
                label={translateKey(GLOBAL.SURVEYS)}
                icon={mdiPollBox}
            />
        );
    }

    return null;
};

SurveysSideNavigation.displayName = 'SideNavigationItem';
